import { TireQuoteItemRecordCustomer, TireQuoteRecordCustomer, TireQuoteRecordList } from '@navio/nsdk';

import { getPickerBucket } from './statusMapping';

type OfferBuckets = {
  pending: TireQuoteRecordList[];
  accepted: TireQuoteRecordList[];
  declined: TireQuoteRecordList[];
};

type OfferSelection = {
  offer: TireQuoteRecordCustomer;
  quoteItem: TireQuoteItemRecordCustomer;
};

export function getOfferBuckets(offers: TireQuoteRecordList[]): OfferBuckets {
  return offers.reduce<OfferBuckets>(
    (acc, offer) => {
      acc[getPickerBucket(offer)].push(offer);
      return acc;
    },
    { pending: [], accepted: [], declined: [] }
  );
}

export function sortPendingOfferList(offers: TireQuoteRecordList[]): TireQuoteRecordList[] {
  return [...offers].sort(
    (a, b) => new Date(b.updatedAt ?? b.createdAt).getTime() - new Date(a.updatedAt ?? a.createdAt).getTime()
  );
}

export function sortAcceptedOffers(offers: TireQuoteRecordList[]): TireQuoteRecordList[] {
  return [...offers].sort(
    (a, b) =>
      new Date(b.selectedAt ?? b.updatedAt ?? b.createdAt).getTime() -
      new Date(a.selectedAt ?? a.updatedAt ?? a.createdAt).getTime()
  );
}

export function getOfferSelections(
  offers: TireQuoteRecordCustomer[],
  selectedQuoteItemId: Record<number, number>
): OfferSelection[] {
  return offers.flatMap((offer) => {
    const quoteItemId = selectedQuoteItemId[offer.id];
    if (quoteItemId == null) {
      return [];
    }

    const quoteItem = offer.quoteItems.find((item) => item.id === quoteItemId);
    return quoteItem ? [{ offer, quoteItem }] : [];
  });
}

export function filterSelectionByOffers(
  offers: TireQuoteRecordCustomer[],
  selectedQuoteItemId: Record<number, number>
): Record<number, number> {
  const validOfferIds = new Set(offers.map((offer) => offer.id));

  return Object.entries(selectedQuoteItemId).reduce<Record<number, number>>((acc, [offerId, quoteItemId]) => {
    const numericOfferId = Number(offerId);
    if (validOfferIds.has(numericOfferId)) {
      acc[numericOfferId] = quoteItemId;
    }
    return acc;
  }, {});
}
